import api from '../../../../../configurations/service';
import { MODELO } from '../enums/Documento';
import * as types from './mutation-types';

export function setGeneratePrint(context, status) {
  context.commit(types.SET_GENERATE_PRINT, status);
  localStorage.setItem('generatePrint', status);
}

export async function getGeneratePrint(context) {
  const status = await localStorage.getItem('generatePrint');
  if (status === 'true') {
    context.commit(types.SET_GENERATE_PRINT, status);
  }
  return status;
}

export const getCheckouts = async (context, params = {}) => {
  const { data } = await api().post('fiscal.get-checkout', params);
  context.commit(types.SET_CHECKOUTS, data);
};

export const printComprovanteGerencial = async (context, params = {}) => {
  const { data } = await api().post('fiscal.get-comprovante-gerencial-url', params);
  return data;
};

export const changePriceWhenIssuing = async (context, params) => {
  await api().post('fiscal.change-price-when-issuing', params);
};

export const postCheckout = async (context, value) => {
  const { data } = await api().post('fiscal.get-checkout', { value });
  context.commit(types.POST_CHECKOUT, data);
};

export const setCheckouts = async (context, value, id) => {
  const { data } = await api().post(id ? 'fiscal.put-checkout' : 'fiscal.post-checkout', value);
  context.commit(types.SET_CHECKOUTS, data);
};

export async function getSatTransmitter(context) {
  const { data } = await api().get('fiscal.get-sat-transmitter');
  context.commit(types.SET_SAT_TRANSMITTER, data);
}

export function setDiscount(context, discount) {
  context.commit(types.SET_DISCOUNT, discount);
}

export function setExtraValue(context, extraValue) {
  context.commit(types.SET_EXTRA_VALUE, extraValue);
}

export function setDiscountItem(context, discount = { valueDiscount: null }) {
  context.commit(types.SET_DISCOUNT_ITEM, discount);
}

export function setExtraValueItem(context, extraValue = { valueExtraValue: null }) {
  context.commit(types.SET_EXTRA_VALUE_ITEM, extraValue);
}

export function setTotal(context, total = 0) {
  context.commit(types.SET_TOTAL, total);
}

export const handleModalDiscountExtraValueItem = async (context) => {
  context.commit(types.SET_MODAL_DISCOUNT_EXTRA_VALUE_ITEM);
};

export async function getTotalNota(context, dados) {
  const { data } = await api().post('fiscal.calc-total-nfe', { dados });
  if (data.dados) {
    context.commit(types.GET_TOTAL_NOTA, data.dados.total);
  }
}

export async function fiscalValidateProduct(_, productOfTradeCollection) {
  const { data } = await api().post('fiscal.product-validate', {
    productOfTradeCollection,
    modelo: MODELO.NFCE,
  });
  const { messages } = data;
  return messages;
}
